import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import classes from './tabs.module.scss';
import accountHelpers from '../../../../../utils/accountHelpers';
import Button from '../../../../_common/Form/Buttons/Button';
import Info from '../../../../_common/Info/Info';
import Utils from '../../../../../utils/utils';

const Details = ({ info, setRefillModalData }) => {
  const isAdmin = accountHelpers.isInOneOfRoles(['Admin', 'Pharmacy']);
  const isHealthPlan = accountHelpers.isInOneOfRoles(['Health', 'Physician']);
  const isPhysician = accountHelpers.isInRole('Physician');
  const isPatient = accountHelpers.isInOneOfRoles(['Patient']);
  const isRep = accountHelpers.isInOneOfRoles(['Rep']);
  const isManufacturerUsers = accountHelpers.isInOneOfRoles(['Manufacturer Users']);

  const hasPriceAccess = accountHelpers.isInRole('Health')
    && accountHelpers.getUser().healthUser?.[0].canSeePrice;

  const hasProfitAccess = accountHelpers.isInRole('Health')
    && accountHelpers.getUser().healthUser?.[0].canSeeProfit;

  const {
    status, PatientId, location, processedOn, priorAuth, patientPay, copayApproval, copayNetwork, networkPay,
    Product, shipOn, deliveryMethod, trackNum, ETA, paymentOption, quantity, refills, billOnDate, daysSupply,
    refillsRemaining, salesCode, Patient, Physician, directions, secDiagnosis, secInsPay, diagnosis, rxNumber,
    primInsPay, cost, writtenDate, doNotRefill, PhysicianId, ProductsChecklist, ade, newStart,
  } = info;

  const hasChecklistPermission = Product?.manufacturerId && (accountHelpers.isInRole('Admin')
    || (accountHelpers.isInRole('Pharmacy'))
  // && !_.isEmpty(accountHelpers.getUser().Manufacturer))
    || accountHelpers.isInRole('Manufacturer Users'));

  const totalPay = parseFloat((+primInsPay || 0) + (+secInsPay || 0) + (+networkPay || 0) + (+patientPay || 0)).toFixed(2);
  const profit = parseFloat(totalPay - +cost).toFixed(2);
  const margin = parseFloat((profit / totalPay) * 100).toFixed(1);

  const conditions = Patient?.conditions ? Patient?.conditions.split(',').join('\n') : null;
  const allergies = Patient?.allergies ? Patient?.allergies.split(',').join('\n') : null;

  const disablePhysicianLink = isManufacturerUsers || isPatient || !Physician?.firstName || isPhysician;

  const leftBlock = [
    {
      title: 'Processed On',
      render: moment(processedOn).isValid() ? moment(processedOn).format('MM/DD/YYYY') : '-',
    },
    {
      title: 'Patient',
      render: <NavLink
        onClick={(e) => isManufacturerUsers && e.preventDefault()}
        to={`/patients/${PatientId}`}
        className={classes.patient_name}
        style={isManufacturerUsers ? { pointerEvents: 'none' } : {}}
      >
        {`${Patient?.firstName} ${Patient?.lastName}`}
      </NavLink>,
    },
    {
      title: 'Date of birth',
      render: moment(Patient?.dob).isValid() ? moment(Patient?.dob).format('MM/DD/YYYY') : '-',
    },
    {
      title: 'Phone',
      render: Patient?.phone || '-',
    },

    {
      title: 'Location',
      render: Patient?.location || '-',
    },
    {
      title: 'Email',
      render: Patient?.email || '-',
    },
    {
      title: 'Hub',
      render: Patient?.hub || '-',
    },
    {
      title: 'Physician',
      render: <NavLink
        onClick={(e) => disablePhysicianLink && e.preventDefault()}
        to={`/physicians/${PhysicianId}`}
        className={`${classes.patient_name} ${disablePhysicianLink ? classes.disable : ''}`}
      >
        {Physician?.firstName ? `${Physician?.firstName} ${Physician?.lastName}` : ' - '}
      </NavLink>,
    },
    {
      title: isAdmin ? 'Group' : 'Contact',
      render: isAdmin ? (Physician?.group || '-') : Physician?.contact || '-',
    },
    {
      title: isAdmin ? 'Rep' : 'Phone',
      render: isAdmin ? (Physician?.Representative?.name || '-') : (Physician?.phone || '-'),
    },
    {
      title: isAdmin ? 'Contact' : 'Rep',
      render: isAdmin ? (Physician?.contact || '-') : (Physician?.Representative?.name || '-'),
    },
    {
      title: 'Phone',
      render: Physician?.phone || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Medicine',
      render: Product?.name || '-',
    },
    {
      title: 'NDC',
      render: Product?.NDC || '-',
    },
    {
      title: 'On Hand',
      render: Product?.quantity || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Prior Authorization',
      render: priorAuth || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Location',
      render: location || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Ship on',
      render: moment(shipOn).isValid() ? moment(shipOn).format('MM/DD/YYYY') : '-',
    },
    {
      title: 'Delivery Method',
      render: deliveryMethod || '-',
      hidden: !isAdmin && !isHealthPlan && !isRep,
    },
    {
      title: 'Tracking Number',
      render: trackNum || '-',
      hidden: !isAdmin && !isHealthPlan && !isRep,
    },
    {
      title: 'ETA',
      render: moment(ETA).isValid() ? moment(ETA).format('MM/DD/YYYY') : '-',
      hidden: !isAdmin && !isHealthPlan && !isRep,
    },
    {
      title: 'Status',
      render: status || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Instructions',
      render: directions || '-',
    },
  ];

  const rightBlock = [
    {
      title: 'Written Date',
      render: moment(writtenDate).isValid() ? moment(writtenDate).format('MM/DD/YYYY') : '-',

    },
    {
      title: 'Bill On',
      render: (moment(billOnDate).isValid() ? moment(billOnDate).format('MM/DD/YYYY') : '-'),
      hidden: !(isAdmin || accountHelpers.isInRole('Health')),
    },
    {
      title: 'Prior Authorization',
      render: (priorAuth || '-'),
      hidden: isAdmin,
    },
    {
      title: 'RX Number',
      render: rxNumber || '-',
    },
    {
      title: isAdmin ? 'Diagnosis' : 'Location',
      render: isAdmin ? (diagnosis || '-') : (location || '-'),
    },
    {
      title: 'Secondary Diagnosis',
      render: secDiagnosis || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Refill #',
      render: refills || '0',
    },
    {
      title: 'Refills Remaining',
      render: <>
        {refillsRemaining || '0'}

        <div className={classes.refill_btn_wrapper}>
          {doNotRefill
            ? (
              <div
                className={classes.do_not_refill}
              >
                DO NOT REFILL
              </div>
            )

            : (isAdmin
              && (
                <Button
                  className={classes.refill_btn}
                  title={+refillsRemaining === -1 ? 'Renew' : 'Refill'}
                  onClick={() => setRefillModalData(true)}
                  reverseColor
                />
              ))}
        </div>
      </>,
    },
    {
      title: 'Quantity',
      render: quantity || '0',
    },
    {
      title: 'Days Supply',
      render: daysSupply || '0',
    },
    {
      title: isAdmin ? 'Sales Code' : 'Patient Pay',
      render: isAdmin
        ? (salesCode || '')
        : (patientPay ? `$ ${Utils.formattingCurrency(patientPay)}` : '-'),
    },
    {
      title: 'Cost',
      render: cost ? `$ ${Utils.formattingCurrency(cost)}` : '-',
      hidden: !(isAdmin || hasPriceAccess || hasProfitAccess),
    },
    {
      title: 'Primary Insurance Pay',
      render: (+primInsPay ? `$ ${Utils.formattingCurrency(primInsPay)}` : '-'),
      hidden: !(isAdmin || hasPriceAccess),
    },
    {
      title: 'Secondary Insurance Pay',
      render: (+secInsPay ? `$ ${Utils.formattingCurrency(secInsPay)}` : '-'),
      hidden: !(isAdmin || hasPriceAccess),
    },
    {
      title: 'Copay Assistance Status',
      render: copayApproval || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Copay Assistance Network',
      render: copayNetwork || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Copay Assistance Amount',
      render: (+networkPay ? `$ ${Utils.formattingCurrency(networkPay)}` : '-'),
      hidden: !isAdmin,
    },
    {
      title: 'Patient Pay',
      render: (+patientPay ? `$ ${Utils.formattingCurrency(patientPay)}` : '-'),
      hidden: !(isAdmin || hasPriceAccess),
    },
    {
      title: 'Payment Option',
      render: paymentOption || '-',
      hidden: !(isAdmin || hasPriceAccess),
    },
    {
      title: 'Total Pay',
      render: (+totalPay ? `$ ${Utils.formattingCurrency(totalPay)}` : '-'),
      hidden: !(isAdmin || hasPriceAccess),
    },
    {
      title: 'Profit',
      render: (+profit ? `$ ${Utils.formattingCurrency(profit)}` : '-'),
      hidden: !(isAdmin || hasProfitAccess),
    },
    {
      title: 'Margin',
      render: (+margin ? `${margin}%` : '-'),
      hidden: !isAdmin,
    },
  ];

  const checklist = [
    {
      title: 'Risk Category',
      render: ProductsChecklist?.riskCategory || '-',
    },
    // {
    //   title: 'Authorization #',
    //   render: ProductsChecklist?.authorizationNo || '-',
    // },
    {
      title: 'Confirmation Number',
      render: ProductsChecklist?.confirmationNo || '-',
    },
    {
      title: 'Confirmation Date',
      render: ProductsChecklist?.confirmationDate && moment(ProductsChecklist?.confirmationDate).isValid()
        ? moment(ProductsChecklist?.confirmationDate).format('MM/DD/YYYY') : '-',
    },
    // {
    //   title: 'Counselor',
    //   render: ProductsChecklist?.counselorName || '-',
    // },
    // {
    //   title: 'Counsel Date',
    //   render: ProductsChecklist?.counselingDate && moment(ProductsChecklist?.counselingDate).isValid()
    //     ? moment(ProductsChecklist?.counselingDate).format('MM/DD/YYYY') : '-',
    // },
    // {
    //   title: 'Checklist',
    //   render: ProductsChecklist?.counselorSignature ? 'Yes' : 'No',
    // },
    // {
    //   title: 'ADE',
    //   render: ade ? 'Yes' : 'No',
    // },
    // {
    //   title: 'New Start',
    //   render: newStart ? 'Yes' : 'No',
    // },
    // {
    //   title: 'Med Guide',
    //   render: (ProductsChecklist?.femaleMedicationGuideProvided || ProductsChecklist?.femaleNonRepMedicationGuideProvided
    //     || ProductsChecklist?.maleMedicationGuideProvided) ? 'Yes' : 'No',
    // },
  ];

  const insurance = (type) => [
    {
      title: 'Plan: ',
      render: info?.[type]?.plan || '-',
      hidden: !isAdmin,
    },
    {
      title: 'BIN: ',
      render: info?.[type]?.BIN || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Group: ',
      render: info?.[type]?.insGroup || '-',
      hidden: !isAdmin,
    },
    {
      title: 'ID: ',
      render: info?.[type]?.insID || '-',
      hidden: !isAdmin,
    },
    {
      title: 'PCN: ',
      render: info?.[type]?.PCN || '-',
      hidden: !isAdmin,
    },
    {
      title: 'Type: ',
      render: info?.[type]?.insType || '-',
      hidden: !isAdmin,
    },
  ];

  return (
    <div className={classes.details_wrapper}>
      <div className={classes.left_block}>
        {leftBlock
          .filter((l) => (accountHelpers.getUser().id === 601
            ? (l.title !== 'Patient' && l.title !== 'Physician')
            : l))
          .map(({ title, render, hidden }, i) => (
            !hidden && (
            <div
              key={`${title} + ${i}`}
              className={classes.render_wrapper}
            >
              <div className={classes.title}>
                {title}
              </div>

              <div className={classes.render}>
                {render}
              </div>
            </div>
            )
          ))}

        {isAdmin && (
          <>
            <div className={classes.render_wrapper}>
              <div className={classes.title}>
                Primary Insurance
              </div>

              <div className={classes.render}>
                {insurance('Prim').map(({ title, render }) => (
                  <div key={title} className={classes.insurance}>{`${title} ${render}`}</div>
                ))}
              </div>
            </div>

            <div className={classes.render_wrapper}>
              <div className={classes.title}>
                Secondary Insurance
              </div>

              <div className={classes.render}>
                {insurance('Sec').map(({ title, render }) => (
                  <div key={title} className={classes.insurance}>{`${title} ${render}`}</div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>

      <div className={classes.middle_block}>
        {rightBlock.map(({ title, render, hidden }, i) => (
          !hidden && (
            <div
              key={`${title} + ${i}`}
              className={classes.render_wrapper}
            >
              <div className={classes.title}>
                {title}
              </div>

              <div className={classes.render}>
                {render}
              </div>
            </div>
          )
        ))}
      </div>

      <div className={classes.right_block}>
        <Info title="Co-morbid conditions">
          {conditions}
        </Info>

        <Info title="Allergies">
          {allergies}
        </Info>

        {isAdmin && (
          <>
            <Info
              title="Patient Warning"
              patientWarning
            >
              {Patient?.patientWarning || 'None'}
            </Info>

            <Info
              title="Physician Warning"
              physicianWarning
            >
              {Physician?.physicianWarning || 'None'}
            </Info>
          </>
        )}

        <div className={classes.middle_block}>
          {hasChecklistPermission && checklist.map(({ title, render, hidden }, i) => (
            !hidden && (
            <div
              key={`${title} + ${i}`}
              className={classes.render_wrapper}
            >
              <div className={classes.title}>
                {title}
              </div>

              <div className={classes.render}>
                {render}
              </div>
            </div>
            )
          ))}
        </div>
      </div>
    </div>
  );
};

Details.propTypes = {
  info: PropTypes.object.isRequired,
  setRefillModalData: PropTypes.func.isRequired,
};

export default Details;
